import { render } from "./companyChannels.vue?vue&type=template&id=f40a31d2"
import script from "./companyChannels.vue?vue&type=script&lang=js"
export * from "./companyChannels.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__